import React, { useState, useEffect } from "react";
import MainContainer from "../../container/MainContainer";
import Arrow from "../../images/Arrow-Right.svg";
import GeneralInfo from "./GeneralInfo";
import OpeningHours from "./OpeningHours";
import ReviewPublish from "./ReviewPublish";
import { Link, useLocation } from "react-router-dom";
import { hasuraClient } from "../../apolloClient";
import { useQuery, useMutation } from "@apollo/react-hooks";
import { EDIT_ATTRACTION } from "../../mutation/EditAttraction";
import AttractionAddedSuccess from "../Popup/AttractionAddedSuccess";
import ExitAttraction from "../Popup/ExitAttraction";
import AttractionError from "../Popup/AttractionError";
import { GET_TYPE_OF_ATTRACTIONS } from "../../query/getTypeOfAttraction";
import AttractionPopup from "../Popup/AttractionPopup";

const EditAttractionLayout = (props) => {
  const { id } = props.match.params;

  const [modalShowSuccess, setmodalShowSuccess] = useState(false);
  const [modalShowExit, setmodalShowExit] = useState(false);
  const [modalShowError, setmodalShowError] = useState(false);
  const [errorMessage, seterrorMessage] = useState();
  const [modalShowD, setModalShowD] = React.useState(false);

  const [attractionName, setAttractionName] = useState("");
  const [description, setDescription] = useState("");
  const [categories, setCategories] = useState("");

  const [uploadedImg, setUploadedImg] = useState("");
  const [location, setLocation] = useState("");
  const [locationG, setLocationG] = useState("");
  const [TuOpen, setTuOpen] = useState("");
  const [TuClose, setTuClose] = useState("");
  const [WeOpen, setWeOpen] = useState("");
  const [WeClose, setWeClose] = useState("");
  const [ThOpen, setThOpen] = useState("");
  const [sameEveryDay, setsameEveryDay] = useState(false);
  const [opencloseTimeError, setopencloseTimeError] = useState(false);
  const [MoOpenSame, setMonOpenSame] = useState("");
  const [MoCloseSame, setMonCloseSame] = useState("");
  const [MoOpen, setMonOpen] = useState("");
  const [MoClose, setMonClose] = useState("");

  const [ThClose, setThClose] = useState("");
  const [FrOpen, setFrOpen] = useState("");
  const [FrClose, setFrClose] = useState("");
  const [SaOpen, setSaOpen] = useState("");
  const [SaClose, setSaClose] = useState("");
  const [SuOpen, setSuOpen] = useState("");
  const [SuClose, setSuClose] = useState("");
  const [workingMoSame, setWorkingMoSame] = useState(true);
  const [workingMo, setWorkingMo] = useState(true);
  const [workingTu, setWorkingTu] = useState(true);
  const [workingWe, setWorkingWe] = useState(true);
  const [workingTh, setWorkingTh] = useState(true);
  const [workingFr, setWorkingFr] = useState(true);
  const [workingSa, setWorkingSa] = useState(true);
  const [workingSu, setWorkingSu] = useState(true);

  const [sameTimeDays, setsameTimeDays] = React.useState([
    {
      dayName: "Monday",
      button_status: false,
      open: MoOpenSame,
      close: MoCloseSame,
      openDate: null,
      closeDate: null,
    },
    {
      open: MoOpenSame,
      close: MoCloseSame,
      dayName: "Tuesday",
      button_status: false,
      openDate: null,
      closeDate: null,
    },
    {
      dayName: "Wednesday",
      button_status: false,
      open: MoOpenSame,
      close: MoCloseSame,
      openDate: null,
      closeDate: null,
    },
    {
      open: MoOpenSame,
      close: MoCloseSame,
      dayName: "Thursday",
      button_status: false,
      openDate: null,
      closeDate: null,
    },
    {
      dayName: "Friday",
      button_status: false,
      open: MoOpenSame,
      close: MoCloseSame,
      openDate: null,
      closeDate: null,
    },
    {
      dayName: "Saturday",
      button_status: false,
      open: MoOpenSame,
      close: MoCloseSame,
      openDate: null,
      closeDate: null,
    },
    {
      open: MoOpenSame,
      close: MoCloseSame,
      dayName: "Sunday",
      button_status: false,
      openDate: null,
      closeDate: null,
    },
  ]);

  const [days, setDays] = React.useState([
    {
      dayName: "Monday",
      button_status: false,
      open: MoOpen,
      close: MoClose,
      openDate: null,
      closeDate: null,
    },
    {
      dayName: "Tuesday",
      button_status: false,
      open: TuOpen,
      close: TuClose,
      openDate: null,
      closeDate: null,
    },
    {
      dayName: "Wednesday",
      button_status: false,
      open: WeOpen,
      close: WeClose,
      openDate: null,
      closeDate: null,
    },
    {
      dayName: "Thursday",
      button_status: false,
      open: ThOpen,
      close: ThClose,
      openDate: null,
      closeDate: null,
    },
    {
      dayName: "Friday",
      button_status: false,
      open: FrOpen,
      close: FrClose,
      openDate: null,
      closeDate: null,
    },
    {
      dayName: "Saturday",
      button_status: false,
      open: SaOpen,
      close: SaClose,
      openDate: null,
      closeDate: null,
    },
    {
      dayName: "Sunday",
      button_status: false,
      open: SuOpen,
      close: SuClose,
      openDate: null,
      closeDate: null,
    },
  ]);

  const locationVal = useLocation();
  const state = locationVal.state;

  const { data: categoriesData } = useQuery(GET_TYPE_OF_ATTRACTIONS, {
    client: hasuraClient,
  });

  const [EditAttraction] = useMutation(EDIT_ATTRACTION, {
    client: hasuraClient,
  });

  const [currentStep, setCurrentStep] = useState(0);

  const [data, setData] = useState(state);

  const makeRequest = (formData) => {
    let cordinate = formData?.location;
    EditAttraction({
      variables: {
        id: id,
        name: `${formData.name}`,
        description: `${formData.description}`,
        image_url: `${formData.image_url}`,
        image_path: `dev/council_profile/`,
        type_of_attraction: `${formData.categories}`,
        open_hours:
          typeof formData?.openingHours === "object"
            ? JSON.stringify(formData?.openingHours)
            : formData?.openingHours,
        same_open_hours: formData?.same_open_hours,
        location_text: `${formData?.location_text}`,
        location: cordinate,
      },
    })
      .then(() => {
        setModalShowD(false);
        setmodalShowSuccess(true);
      })
      .catch((e) => {
        const errors = e.graphQLErrors;
        if (errors[0].message.includes("Uniqueness violation")) {
          seterrorMessage(
            "Attraction Name already exist. Please choose a new one!"
          );
          setmodalShowError(true);
        } else {
          seterrorMessage(`${errors[0].message}`);
          setmodalShowError(true);
        }
      });
  };

  const handleNextStep = (newData, final = false, isSaveandExit = false) => {
    setData((prev) => ({ ...prev, ...newData }));
    let finalData = { ...data, ...newData };

    if (final) {
      makeRequest(finalData);
      return;
    }

    if (isSaveandExit) {
      setModalShowD(true);
    } else {
      setCurrentStep((prev) => prev + 1);
    }
  };

  const handleBackStep = () => {
    setCurrentStep((prev) => prev - 1);
  };

  useEffect(() => {
    if (data) {
      setAttractionName(`${data?.name ? data?.name : ""}`);
      setDescription(`${data?.description ? data?.description : ""}`);
      setCategories(`${data?.categories ? data?.categories : ""}`);

      setUploadedImg(data?.image_url ? data?.image_url : "");
      setLocation(data?.location_text ? data?.location_text : "");
      setLocationG(data?.location ? data?.location : "");
    }
  }, [data]);

  const handleNextClick = (dataVal, isSaveExit) => {
    if (sameEveryDay === true) {
      if (
        sameTimeDays[0].open != null &&
        sameTimeDays[0].close != null &&
        sameTimeDays[0]?.open >= sameTimeDays[0]?.close
      ) {
        setopencloseTimeError(true);
      } else {
        if (isSaveExit) {
          handleNextStep(
            {
              ...dataVal,
              open_hours: sameTimeDays,
              same_open_hours: sameEveryDay,
              openingHours: JSON.stringify(sameTimeDays),
            },
            false,
            true
          );
        } else {
          handleNextStep({
            open_hours: sameTimeDays,
            same_open_hours: sameEveryDay,
            openingHours: JSON.stringify(sameTimeDays),
          });
        }
      }
    } else {
      days.some((day) => {
        if (day.open != null && day.close != null && day.open >= day.close) {
          setopencloseTimeError(true);
          return true;
        } else {
          if (day.dayName === "Sunday") {
            if (isSaveExit) {
              handleNextStep(
                {
                  ...dataVal,
                  open_hours: days,
                  same_open_hours: sameEveryDay,
                  openingHours: JSON.stringify(days),
                },

                false,
                true
              );
            } else {
              handleNextStep({
                open_hours: days,
                same_open_hours: sameEveryDay,
                openingHours: JSON.stringify(days),
              });
            }
            return false;
          }
        }
      });
    }
  };

  const steps = [
    <GeneralInfo
      next={handleNextStep}
      data={data}
      categoriesData={categoriesData}
      type="edit"
      attractionName={attractionName}
      setAttractionName={setAttractionName}
      description={description}
      setDescription={setDescription}
      categories={categories}
      setCategories={setCategories}
      uploadedImg={uploadedImg}
      setUploadedImg={setUploadedImg}
      location={location}
      setLocation={setLocation}
      locationG={locationG}
      setLocationG={setLocationG}
    />,
    <OpeningHours
      ThClose={ThClose}
      setThClose={setThClose}
      FrOpen={FrOpen}
      setFrOpen={setFrOpen}
      FrClose={FrClose}
      back={handleBackStep}
      data={data}
      type="edit"
      sameEveryDay={sameEveryDay}
      setsameEveryDay={setsameEveryDay}
      opencloseTimeError={opencloseTimeError}
      setopencloseTimeError={setopencloseTimeError}
      MoOpenSame={MoOpenSame}
      setMonOpenSame={setMonOpenSame}
      MoCloseSame={MoCloseSame}
      setMonCloseSame={setMonCloseSame}
      MoOpen={MoOpen}
      setMonOpen={setMonOpen}
      MoClose={MoClose}
      setMonClose={setMonClose}
      TuOpen={TuOpen}
      setTuOpen={setTuOpen}
      TuClose={TuClose}
      setTuClose={setTuClose}
      WeOpen={WeOpen}
      setWeOpen={setWeOpen}
      WeClose={WeClose}
      setWeClose={setWeClose}
      ThOpen={ThOpen}
      setThOpen={setThOpen}
      setFrClose={setFrClose}
      SaOpen={SaOpen}
      setSaOpen={setSaOpen}
      SaClose={SaClose}
      setSaClose={setSaClose}
      SuOpen={SuOpen}
      setSuOpen={setSuOpen}
      SuClose={SuClose}
      setSuClose={setSuClose}
      workingMoSame={workingMoSame}
      setWorkingMoSame={setWorkingMoSame}
      workingMo={workingMo}
      setWorkingMo={setWorkingMo}
      workingTu={workingTu}
      setWorkingTu={setWorkingTu}
      workingWe={workingWe}
      setWorkingWe={setWorkingWe}
      workingTh={workingTh}
      setWorkingTh={setWorkingTh}
      workingFr={workingFr}
      setWorkingFr={setWorkingFr}
      workingSa={workingSa}
      setWorkingSa={setWorkingSa}
      workingSu={workingSu}
      setWorkingSu={setWorkingSu}
      setsameTimeDays={setsameTimeDays}
      sameTimeDays={sameTimeDays}
      setDays={setDays}
      days={days}
      handleNextClick={handleNextClick}
    />,
    <ReviewPublish
      back={handleBackStep}
      next={handleNextStep}
      data={data}
      categoriesData={categoriesData}
      type="edit"
    />,
  ];

  return (
    <MainContainer active="attractions">
      <AttractionPopup
        title={"Your changes will be saved. Are you sure you want to exit?"}
        cancelButtonText={"No"}
        show={modalShowD}
        onHide={setModalShowD}
        setModalShowD={setModalShowD}
        next={handleNextStep}
        data={data}
        makeRequest={makeRequest}
      />
      <section className="attraction-block">
        <AttractionError
          error={errorMessage}
          show={modalShowError}
          onHide={() => setmodalShowError(false)}
        />
        <ExitAttraction
          show={modalShowExit}
          onHide={() => setmodalShowExit(false)}
        />
        <AttractionAddedSuccess
          edit={true}
          show={modalShowSuccess}
          name={data?.name}
          onHide={() => setmodalShowSuccess(false)}
        />
        <div className="main-title">
          <div className="back-button">
            <Link
              to="#"
              onClick={() => {
                if (currentStep === 0) {
                  handleNextStep(
                    {
                      categories: categories,
                      description: description,
                      name: attractionName,
                      image_url: uploadedImg,
                      location_text: location,
                      location: locationG,
                      open_hours: sameTimeDays,
                      same_open_hours: sameEveryDay,
                    },
                    false,
                    true
                  );
                } else {
                  handleNextClick(
                    {
                      categories: categories,
                      description: description,
                      name: attractionName,
                      image_url: uploadedImg,
                      location_text: location,
                      location: locationG,
                    },
                    true
                  );
                }
              }}
            >
              <img src={Arrow} alt="arrow right" />
            </Link>
            <h2>Edit attraction</h2>
          </div>
          <div className="edit-btn">
            <button
              type="submit"
              onClick={() => {
                if (currentStep === 0) {
                  handleNextStep(
                    {
                      categories: categories,
                      description: description,
                      name: attractionName,
                      image_url: uploadedImg,
                      location_text: location,
                      location: locationG,
                      open_hours: sameTimeDays,
                      same_open_hours: sameEveryDay,
                    },
                    false,
                    true
                  );
                } else {
                  handleNextClick(
                    {
                      categories: categories,
                      description: description,
                      name: attractionName,
                      image_url: uploadedImg,
                      location_text: location,
                      location: locationG,
                    },
                    true
                  );
                }
              }}
            >
              Save and exit
            </button>
          </div>
        </div>
        <div className="attraction-step">
          <ul className="attraction-menu">
            <li className={currentStep === 0 ? "active" : ""}>
              <p>1. General info</p>
            </li>
            <li className={currentStep === 1 ? "active" : ""}>
              <p>2. Opening Hours</p>
            </li>
            <li className={currentStep === 2 ? "active" : ""}>
              <p>3. Review & Publish</p>
            </li>
          </ul>

          {steps[currentStep]}
        </div>
      </section>
    </MainContainer>
  );
};

export default EditAttractionLayout;
